import { render } from "./EditaCuenta.vue?vue&type=template&id=252b8955&scoped=true"
import script from "./EditaCuenta.vue?vue&type=script&lang=js"
export * from "./EditaCuenta.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./EditaCuenta.vue?vue&type=style&index=1&id=252b8955&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252b8955"]])

export default __exports__